import { apiBaseURL, authActionType, toastifyType } from "../../../constant";
import { setLoading } from "../loadingAction";
import apiConfig from '../../../config/apiConfig';
import { addTost } from "../toastAction";
import { environment } from "../../../config/environment";

export const register = (user, navigate) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await apiConfig.post(apiBaseURL.ADMIN_REGISTER, user);
    if (response?.data?.success) {
      dispatch({ type: authActionType.REGISTER, payload: response.data.data });
      dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response.data.message }));
      navigate('/login');
    }
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
    console.error('error', error);
  }
};